import { useTranslation } from 'react-i18n-lite'

import { Icon } from '@yes.technology/react-toolkit'

import { PhotoMark } from 'modules/interaction/components/ActivityInput/ActivityMarkPhoto/PhotoMarkingModal'
import {
  MarkBadge,
  MarkOverlay,
  MarksOverlayLayer
} from 'modules/interaction/components/ActivityInput/ActivityMarkPhoto/ActivityMarkPhoto.styles'
import { useRef, useState } from 'react'
import { useTheme } from 'styled-components'
import { mostReadable } from '@ctrl/tinycolor'

type Props = {
  image: string
  onCancel: () => void
  marks?: PhotoMark[]
  markColor?: string
}

const ViewPhoto = ({ image, onCancel, marks, markColor }: Props) => {
  const { t } = useTranslation()

  const [imgSize, setImgSize] = useState({ width: 0, height: 0 })

  const imgRef = useRef<HTMLImageElement | null>(null)

  const theme = useTheme()

  const markOverlayColor = markColor || theme.colors.primary
  const badgeTextColor = mostReadable(markOverlayColor, [
    theme.colors.blackText,
    theme.colors.whiteText
  ])?.toHexString()

  return (
    <div
      className='webcam d-flex flex-column w-100 h-100 position-fixed  justify-content-center align-items-center'
      style={{
        background: '#ffffff',
        top: '0',
        right: '0',
        bottom: '0',
        left: '0',
        zIndex: 2
      }}
    >
      <div className='webcam-header-view'>
        <div className='webcam-header-elements'>
          <button type='button' className='icon-button' onClick={onCancel}>
            <Icon iconName='Close' icSize='small' />
          </button>
          <span>{t('activity-document-photo.webcam.view')}</span>
        </div>
      </div>
      <div
        className='position-relative overflow-hidden'
        style={{ flex: 1, width: 'fit-content' }}
      >
        <img
          ref={imgRef}
          onLoad={() => {
            const img = imgRef.current
            if (img)
              setImgSize({
                width: img.clientWidth,
                height: img.clientHeight
              })
          }}
          src={image}
          className='img-fluid'
          style={{ maxHeight: '100%' }}
          alt={t('activity-document-photo.webcam.screenshot')}
        />

        {marks && (
          <MarksOverlayLayer
            style={{
              width: imgSize.width,
              height: imgSize.height
            }}
          >
            {marks.map((mark, index) => (
              <MarkOverlay
                key={index}
                x={mark.x}
                y={mark.y}
                width={mark.width}
                height={mark.height}
                color={markOverlayColor}
              >
                <MarkBadge
                  backgroundColor={markOverlayColor}
                  textColor={badgeTextColor || theme.colors.whiteText}
                >
                  {`#${index + 1} | ${mark.category.des}`}
                </MarkBadge>
              </MarkOverlay>
            ))}
          </MarksOverlayLayer>
        )}
      </div>
    </div>
  )
}

export default ViewPhoto
